import './styles/AnimationClose.css';

import classNames from 'classnames';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC, MouseEvent } from 'react';

interface Props {
  closeText?: string;
  className?: string;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
}

export const AnimationClose: FC<Props> = ({
  closeText,
  onClick,
  className,
}: Props) => {
  const msg = useLocale();
  return (
    <div
      className={classNames('animation-close__outer', className)}
      onClick={onClick}
    >
      <div className='animation-close__inner'>
        <div className='animation-close__label'>
          {closeText ?? msg.animationClose.close}
        </div>
      </div>
    </div>
  );
};
